import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { BreadCrumbItem } from "@progress/kendo-angular-navigation";
import { environment } from '@environments/environment';


@Component({
  selector: 'profile',
  template: `
  
    <kendo-breadcrumb [items]="breadcrumbItems"> </kendo-breadcrumb>

    <div class="user-info text-center">
      <img src="{{((currentUser.image=='') ? DEFAULT_USER_IMAGE : currentUser.image)}}" class="user-image">
      <div class="user-detail text-center">                    
        <h4>{{currentUser.name}}</h4>
        <p><span class="k-icon k-i-user"></span> {{currentUser.user}}</p>
        <p><span class="k-icon k-i-accessibility"></span> {{currentUser.role}}</p>               
      </div>
    </div>

  `,
  styles: [`
    .user-info {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    .user-image {
      width: 196px;
      border-radius: 50%!important;
      margin-right: 8px;
    }
    .user-detail p {
      margin-bottom: 3px;
    }
    .user-detail> p:first-child {
      padding-top: 40px;
      margin-top: 5px;
    }
    h4 {
      padding-top: 12px;
    }`
  ]
})
export class ProfileComponent {

  //Variables  

  protected currentUser: User;

  public breadcrumbItems: BreadCrumbItem[] = [];

  public numbers: any[] = [];  

  private DEFAULT_USER_IMAGE: string = environment.assets.DEFAULT_USER_IMAGE;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    // super(authService, service, alertService);
    this.authService.currentUser.subscribe(x => this.currentUser = x);
    this.breadcrumbItems = this.getBreadcumItems();

  }

  protected getBreadcumItems(): BreadCrumbItem[] {
    return [
      {
        icon: "home",
        // disabled: true
      },
      {
        text: 'Perfil',
        icon: 'user',
        // disabled: true,
      }
    ];
  }

}
